import { Router } from '@angular/router';
import { ByocUploadContentService } from './../../service/upload-content.service';
import { ByocEpisodeService } from '../../service/episode.service';
import { Component, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-byoc-episode-step-uploaded-content-status-info',
    templateUrl: './uploaded-content-status-info.component.html',
    styleUrls: ['./uploaded-content-status-info.component.scss'],
    standalone: false
})
export class ByocEpisodeStepUploadedContentStatusInfoComponent implements OnDestroy {
    constructor(
        private byocEpisodeService: ByocEpisodeService,
        private byocUploadContentService: ByocUploadContentService,
        private router: Router,
    ) {}

    get contentName() {
        return this.byocEpisodeService.form.get('title')!.value;
    }

    get contentType() {
        return this.byocUploadContentService.uploadType;
    }

    get isReuploadContent() {
        return this.byocUploadContentService.episodeToEditId;
    }

    ngOnDestroy(): void {
        if (this.isReuploadContent) {
            this.router.navigate(['/manager', 'settings', 'content', 'byoc', 'list']);
        }
    }
}
